import percentChanged from "../../../../components/percentChanged/percentChanged";
import { connect } from "react-redux";
export default connect(state => ({ changeValue: state.marketing.totals.introsSoldChange, toolTip: "Percent change from previous month", showBorder: true }))(
  percentChanged
);
